import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Diet = lazyWithPreload(() => import('./Diet'))
export const DietVariant2 = lazyWithPreload(() => import('./DietVariant2'))
export const LikeChatDiet = lazyWithPreload(() => import('./LikeChatDiet'))
